import { DirectiveOptions } from 'vue';
import { ANIMATION_END } from 'constants/css';

const directive: DirectiveOptions = {
  bind(element, binding, vnode) {
    const methodName = binding.expression;
    // @ts-ignore
    const method = vnode.context![methodName];
    element.addEventListener(ANIMATION_END, method, false);
  },

  unbind(element, binding, vnode) {
    const methodName = binding.expression;
    // @ts-ignore
    const method = vnode.context![methodName];
    element.removeEventListener(ANIMATION_END, method);
  },
};

export default directive;
